import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SupplierList from './SupplierList';
import SupplierForm from './SupplierForm';
import SupplierDetail from './SupplierDetail';
import SupplierWineLinkList from './SupplierWineLinkList';
import SupplierWineLinkForm from './SupplierWineLinkForm';

const SupplierRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SupplierList />} />
      <Route path="/create" element={<SupplierForm />} />
      <Route path="/edit/:supplierId" element={<SupplierForm />} />
      <Route path="/:supplierId" element={<SupplierDetail />} />
      <Route path="/:supplierId/wines" element={<SupplierWineLinkList />} />
      <Route path="/:supplierId/wines/add" element={<SupplierWineLinkForm />} />
      <Route path="*" element={<Navigate to="/admin/suppliers" replace />} />
    </Routes>
  );
};

export default SupplierRoutes;
